import { createFileRoute } from '@tanstack/react-router'
import { LabelingStudioPage } from 'pages/labelingStudio/LabelingStudioPage'

import { labelingStudioSearchSchema } from './-searchParams'

const RouteComponent = () => {
  const searchParams = Route.useSearch()
  return <LabelingStudioPage searchParams={searchParams} />
}

export const Route = createFileRoute('/labeling-studio/')({
  component: RouteComponent,
  validateSearch: labelingStudioSearchSchema,
  staticData: {
    title: 'Labeling Studio',
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
      useDynamicViewportHeight: true,
    },
  },
})
